module.exports = "/desktop-app/assets/img/notification.mp3?3a509cfb01c7f5f109301383a030315c";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/audio/notification.mp3
// module id = Izv0
// module chunks = 1